// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"275":"965531ed","697":"98aac332","701":"ca994602"}[chunkId] + ".chunk.css";
};